import { useState } from "react";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import TradingViewChart from "./TradingViewChart";

// Outil « Graphiques avancés » (déplacé depuis la page Cours vers la page Outils)
const TV_PRESETS = [
  { symbol: "BITSTAMP:BTCUSD", label: "Bitcoin" },
  { symbol: "BITSTAMP:ETHUSD", label: "Ethereum" },
  { symbol: "COINBASE:SOLUSD", label: "Solana" },
  { symbol: "NASDAQ:AAPL", label: "Apple" },
  { symbol: "NASDAQ:NVDA", label: "NVIDIA" },
  { symbol: "NASDAQ:TSLA", label: "Tesla" },
  { symbol: "NASDAQ:COIN", label: "Coinbase" },
  { symbol: "NASDAQ:MSTR", label: "Strategy (MicroStrategy)" },
  { symbol: "NYSE:CRCL", label: "Circle" },
  { symbol: "AMEX:SPY", label: "S&P 500 ETF" },
  { symbol: "NASDAQ:QQQ", label: "Nasdaq 100" },
  { symbol: "OTC:NTDOY", label: "Nintendo" },
  { symbol: "NYSE:EBR", label: "Eletrobras" },
  { symbol: "TVC:GOLD", label: "Or" },
  { symbol: "TVC:SILVER", label: "Argent" },
  { symbol: "COMEX:HG1!", label: "Cuivre" },
  { symbol: "AMEX:URA", label: "Uranium (URA)" },
  { symbol: "NYMEX:CL1!", label: "Pétrole WTI" },
  { symbol: "TVC:US10Y", label: "US Treasury 10Y" },
];

export default function AdvancedChartsPanel() {
  const [symbol, setSymbol] = useState("BITSTAMP:BTCUSD");
  return (
    <div data-testid="advanced-charts">
      <div className="flex flex-wrap items-end justify-end gap-4 mb-4 sm:mb-6">
        {/* Téléphone : sélecteur d'actif en pleine largeur */}
        <div className="w-full sm:w-auto sm:min-w-[280px]">
          <Label className="text-xs uppercase tracking-[0.15em] text-zinc-400">Actif</Label>
          <Select value={symbol} onValueChange={setSymbol}>
            <SelectTrigger className="mt-1.5 bg-white/[0.03] border-white/10" data-testid="tv-symbol-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="max-h-80">
              {TV_PRESETS.map((p) => (
                <SelectItem key={p.symbol} value={p.symbol}>
                  {p.label} <span className="text-zinc-500 ml-2 text-xs">{p.symbol}</span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      {/* Téléphone : graphique moins haut, pour tenir dans l'écran */}
      <TradingViewChart symbol={symbol} height={typeof window !== "undefined" && window.innerWidth < 640 ? 560 : 860} />
      <p className="text-xs text-zinc-500 mt-3">
        Astuce : tapez directement un symbole dans la barre du graphique (ex. NASDAQ:AAPL, BINANCE:BTCUSDT).
      </p>
    </div>
  );
}
